// extracted by mini-css-extract-plugin
export default {"status-tag":"StatusTag_status-tag__Gb+mL"};